import { createContext, PropsWithChildren, useContext, useState } from 'react';

const DetailPanelHostContext = createContext<HTMLElement | null>(null);

/** App-wide slot that every page's detail panel renders into. */
export const DetailPanelProvider = ({ children }: PropsWithChildren) => {
    const [host, setHost] = useState<HTMLDivElement | null>(null);

    return (
        <DetailPanelHostContext.Provider value={host}>
            {children}
            <div ref={setHost} />
        </DetailPanelHostContext.Provider>
    );
};

export const useDetailPanelHost = () => useContext(DetailPanelHostContext);
